// SpinnerPage.jsx
import React from 'react';
import { CircularProgress, Box, Typography } from '@mui/material';

export default function SpinnerPage() {
  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#f9f9f9'
      }}
    >
      <CircularProgress size={60} thickness={4} />
      <Typography variant="h6" sx={{ mt: 2, color: '#555' }}>
        Loading...
      </Typography>
    </Box>
  );
}
